import React from 'react';
import { ComissionForm } from './../../../components/ComissionForm';

export const CommissionComponent = (props: any) => <ComissionForm {...props} />;
